var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{staticClass:"st0",attrs:{"d":"M 40,521.8 424.3,295 40.8,79.1 85.2,0.4 537,254.7 c 14.1,7.9 22.8,22.7 23,38.9 0,0.2 0,0.3 0,0.5 0,16 -8.4,30.8 -22.2,38.9 L 86,599.6 Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }